import React from 'react';
import { siteInfo } from '../data/mockData';
import { Instagram, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black py-16 border-t border-gray-900">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Logo & Tagline */}
          <div className="flex flex-col items-center md:items-start">
            <span className="text-white text-4xl font-bold tracking-[0.15em]" style={{ fontFamily: 'Georgia, serif' }}>
              GOC
            </span>
            <span className="text-white text-[10px] tracking-[0.25em] uppercase mt-1 mb-4">
              God of Cricket
            </span>
            <p className="text-gray-500 text-sm text-center md:text-left">
              Empowering cricketers to reach their full potential through world-class training and guidance.
            </p>
          </div>

          {/* Quick Links */}
          <div className="text-center md:text-left">
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <div className="space-y-2">
              <a href="#articles" className="block text-gray-400 hover:text-white transition-colors text-sm">Knowledge Hub</a>
              <a href="#academies" className="block text-gray-400 hover:text-white transition-colors text-sm">Career Pathway</a>
              <a href="#stats" className="block text-gray-400 hover:text-white transition-colors text-sm">Rankings & Stats</a>
              <a href="#gallery" className="block text-gray-400 hover:text-white transition-colors text-sm">Legends Gallery</a>
              <a href="#contact" className="block text-gray-400 hover:text-white transition-colors text-sm">Contact Us</a>
            </div>
          </div>

          {/* Contact Info */}
          <div className="text-center md:text-left">
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center justify-center md:justify-start gap-2 text-gray-400 text-sm">
                <MapPin size={16} />
                <span>{siteInfo.address}</span>
              </div>
              <div className="flex items-center justify-center md:justify-start gap-2 text-gray-400 text-sm">
                <Mail size={16} />
                <a href={`mailto:${siteInfo.email}`} className="hover:text-white transition-colors">{siteInfo.email}</a>
              </div>
              <div className="flex items-center justify-center md:justify-start gap-2 text-gray-400 text-sm">
                <Phone size={16} />
                <a href={`tel:${siteInfo.phone}`} className="hover:text-white transition-colors">{siteInfo.phone}</a>
              </div>
              <a 
                href={siteInfo.instagram} 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center justify-center md:justify-start gap-2 text-gray-400 text-sm hover:text-pink-500 transition-colors"
              >
                <Instagram size={16} />
                <span>Follow us on Instagram</span>
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            © 2025 {siteInfo.name}. All rights reserved. | Empowering Cricket Dreams
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
